"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureList_1 = require("./FeatureList");
exports.default = FeatureList_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/FeatureList/index.js
// module id = 1331
// module chunks = 8